/* E3's regions, and the one a business address falls in (Duncan 2026-10-27, sub applications: "from the address is where
   we sort into buckets. North texas, then south texas, then south east"): by its ZIP code's first three digits, the way
   the Postal Service groups Texas. North Texas is DFW, East Texas, the Panhandle and West Texas; South Texas is Austin,
   Waco, Bryan, San Antonio, Corpus and the Valley; Southeast Texas is Houston, Beaumont and the Gulf Coast (his picks).
   An address outside Texas is "Outside our regions". */
export const REGIONS = ['North Texas', 'South Texas', 'Southeast Texas', 'Outside our regions'];
export const OUTSIDE = 'Outside our regions';

// [first ZIP3, last ZIP3, region]
const TEXAS_ZIP3 = [
  [733, 733, 'South Texas'], // Austin
  [750, 764, 'North Texas'], // Dallas, Fort Worth, Denton, Wichita Falls, Tyler, Longview, Texarkana, Lufkin
  [765, 768, 'South Texas'], // Temple, Killeen, Waco, Brownwood
  [769, 769, 'North Texas'], // San Angelo (West Texas)
  [770, 777, 'Southeast Texas'], // Houston, Beaumont
  [778, 789, 'South Texas'], // Bryan, College Station, Victoria, San Antonio, Corpus Christi, the Valley, Austin, Del Rio
  [790, 799, 'North Texas'], // Amarillo, Lubbock, Abilene, Midland, El Paso
  [885, 885, 'North Texas'], // El Paso
];

/** The region of a business address: by its ZIP in Texas, else Outside our regions (null without a ZIP). */
export function regionOfAddress(zip, state) {
  const z = /^\s*(\d{3})\d{2}/.exec(String(zip || ''));
  if (!z) return null;
  if (state && String(state).trim().toUpperCase() !== 'TX') return OUTSIDE;
  const n = Number(z[1]);
  const hit = TEXAS_ZIP3.find(([a, b]) => n >= a && n <= b);
  return hit ? hit[2] : OUTSIDE;
}
